// @ts-nocheck
import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';

import appActions from 'common/support/applicationActions';
import focusManager from 'support/focus/FocusManager';

import Focusable from './Focusable';

const Selectable = ({ onSelect, onAction, ttsText, render, ...rest }) => {
  const onActionOverride = useCallback(
    action => {
      if (action === appActions.select) {
        onSelect();
        return true;
      }

      return onAction(action);
    },
    [onSelect, onAction],
  );

  const ref = useRef();
  const onClick = useCallback(() => {
    if (ref.current) {
      const focusId = ref.current.getAttribute('data-fcsid');

      if (focusManager.currentFocusId !== focusId) {
        focusManager.setCurrentFocus(focusId);
      }
    }
  }, []);

  return (
    <Focusable
      onAction={onActionOverride}
      render={render}
      ref={ref}
      onClick={onClick}
      ttsText={ttsText}
      {...rest}
    />
  );
};

Selectable.propTypes = {
  render: PropTypes.func.isRequired,
  onSelect: PropTypes.func,
  onAction: PropTypes.func,
  ttsText: PropTypes.string,
};

Selectable.defaultProps = {
  onSelect: () => {},
  onAction: () => false,
  ttsText: '',
};

export default React.memo(Selectable);
